const promiseGoodsInfo = {
    namespaced: true,
    state : {
        promiseGoodsCd : '',
        promiseGoodsNm : '',
        promiseGoodstypeCd : '',
        promiseGoodstypeNm : '',
        promiseGoodstypeNm : '',
        prescriptQuantity : '',             //구매수량
        prescriptInfo : {},                 // 사전처방
        promiseGoods : {},                  // 약속상품
        itemInfo : {}                       // 구성상품
    },
    getters: {
        getPromiseGoodsCd (state) {
            return state.promiseGoodsCd
        },
        getPromiseGoodsNm (state) {
            return state.promiseGoodsNm
        },
        getPromiseGoodstypeCd (state) {
            return state.promiseGoodstypeCd
        },
        getPromiseGoodstypeNm (state) {
            return state.promiseGoodstypeNm
        },
        getPrescriptQuantity (state) {
            return state.prescriptQuantity
        },
        getPrescriptInfo (state) {
            return state.prescriptInfo
        },
        getPromiseGoods (state) {
            return state.promiseGoods
        },
        getItemInfo (state) {
            return state.itemInfo
        }
    },
    mutations: {
        setPromiseGoodsCd (state, payload) {
            state.promiseGoodsCd = payload
        },
        setPromiseGoodsNm (state, payload) {
            state.promiseGoodsNm = payload
        },
        setPromiseGoodstypeCd (state, payload) {
            state.promiseGoodstypeCd = payload
        },
        setPromiseGoodstypeNm (state, payload) {
            state.promiseGoodstypeNm = payload
        },
        setPrescriptQuantity (state, payload) {
            state.prescriptQuantity = payload
        },
        setPrescriptInfo (state, payload) {
            state.prescriptInfo = payload
        },
        setPromiseGoods (state, payload) {
            state.promiseGoods = payload
        },
        setItemInfo (state, payload) {
            state.itemInfo = payload
        },
    },
    actions: {
        setPromiseGoodsCd ({commit}, payload) {
            commit('setPromiseGoodsCd', payload)
        },
        setPromiseGoodsNm ({commit}, payload) {
            commit('setPromiseGoodsNm', payload)
        },
        setPromiseGoodstypeCd ({commit}, payload) {
            commit('setPromiseGoodstypeCd', payload)
        },
        setPromiseGoodstypeNm ({commit}, payload) {
            commit('setPromiseGoodstypeNm', payload)
        },
        setPrescriptQuantity ({commit}, payload) {
            commit('setPrescriptQuantity', payload)
        },
        setPrescriptInfo ({commit}, payload) {
            commit('setPrescriptInfo', payload)
        },
        setPromiseGoods ({commit}, payload) {
            commit('setPromiseGoods', payload)
        },
        setItemInfo ({commit}, payload) {
            commit('setItemInfo', payload)
        },
        setClinicDoctorInfoInit ({commit}) {
            commit('setPromiseGoodsCd', '');
            commit('setPromiseGoodsNm', '');
            commit('setPromiseGoodstypeCd', '');
            commit('setPromiseGoodstypeNm', '');
            commit('setPrescriptQuantity', '');
            commit('setPrescriptInfo', {});
            commit('setPromiseGoods', {});
            commit('setItemInfo', {});
        }
    }
}

export default promiseGoodsInfo